export const apiUrl = "/api/v1/track";

export const defaultTrackColors = [
  '#800000', '#00008B', '#006400', '#FF8C00', '#4B0082',
  '#8B008B', '#008B8B', '#B22222', '#228B22', '#DAA520'
];
